'use es6';

import styled from 'styled-components';
import PropTypes from 'prop-types';
import UIComponentsCode from 'UIComponents/elements/Code';
import { GREAT_WHITE, GYPSUM } from 'HubStyleTokens/colors';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
export const ScopeCode = styled(UIComponentsCode).withConfig({
  displayName: "ScopesList__ScopeCode",
  componentId: "sc-9d70a1-0"
})(["padding:4px;border:1px solid ", ";background-color:", ";"], GREAT_WHITE, GYPSUM);
const ScopesList = ({
  scopes
}) => {
  return /*#__PURE__*/_jsx(UIList, {
    inline: true,
    children: scopes.map(scope => /*#__PURE__*/_jsx(ScopeCode, {
      children: scope
    }, scope))
  });
};
ScopesList.propTypes = {
  scopes: PropTypes.arrayOf(PropTypes.string)
};
export default ScopesList;